export enum TaxonomyAction {
  APPROVE = 'approve',
  UNMAP = 'unmap',
  EDIT = 'edit',
  APPROVE_ALL = 'approveAll'
}
